import React from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Gamepad2,
  Gift,
  Sparkles,
  Facebook,
  Instagram,
  Twitter,
  Youtube,
} from "lucide-react";
import { FcGoogle } from "react-icons/fc";
import { motion } from "framer-motion";
import { Player } from "@lottiefiles/react-lottie-player";
import StarfieldBackground from "./StarfieldBackground";
import { auth, googleProvider } from "./firebase";
import { signInWithPopup } from "firebase/auth";
import { createUserData } from "./utils/userData"; // ✅ añadimos esta importación
import { useUser } from "./UserContext"; // 👈 importar el contexto

const HomeScreen = () => {
  const { setUser } = useUser(); // ✅ usar el setter global
  const navigate = useNavigate();

  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      await createUserData(user); // ✅ Crear documento del usuario si no existe
      setUser(user); // ✅ Guardamos al usuario en el contexto global
      navigate("/juegos");
      console.log("Usuario logueado con Google:", user);
    
    } catch (error) {
      if (error.code === "auth/popup-closed-by-user") {
        console.log("El usuario cerró el popup de Google sin completar el login.");
      } else {
        console.error("Error al iniciar sesión con Google:", error);
      }
    }
  };
  
  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center px-4 py-4 overflow-hidden">
      <StarfieldBackground className="absolute top-0 left-0 w-full h-full z-[-1]" />
      
      {/* Logo principal - Ahora está arriba de todo */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="mb-0 z-10"
      >
        <img
          src="Imagenes/home/pixartplay.png"
          alt="PixArt Play"
          className="w-72 md:w-80 mx-auto drop-shadow-lg"
        />
      </motion.div>

      {/* Contenido principal */}
      <div className="relative z-10 max-w-5xl w-full grid grid-cols-1 md:grid-cols-2 gap-1 md:gap-8 items-center">
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="flex justify-center"
        >
          <Player
            autoplay
            loop
            src="https://lottie.host/7e0bd3c6-fe22-475a-88ff-c833237896e2/g0ZZQ9oCCp.json"
            style={{ height: "220px", width: "220px" }}
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="bg-white/10 backdrop-blur-md ring-1 ring-white/20 shadow-2xl rounded-3xl w-full p-4"
        >
          <div className="text-center mb-4">
            <Sparkles className="mx-auto text-yellow-400 w-5 h-5" />
            <h1 className="text-gray-700 text-xl md:text-5xl font-bold tracking-tight drop-shadow-lg mt-1">
              ¡Bienvenido a la Aventura!
            </h1>
            <p className="text-gray-400 mt-1 text-xs md:text-lg">
              Elige tu camino y comienza a ganar
            </p>
          </div>

          <div className="grid gap-3">
            <Link
              to="/juegos"
              className="flex items-center gap-3 px-4 py-2.5 bg-blue-600 hover:bg-blue-700 transition rounded-2xl shadow-md text-white font-medium transform hover:scale-105"
            >
              <Gamepad2 className="w-4 h-4" />
              <span>Jugar</span>
            </Link>

            <button
              onClick={handleGoogleLogin}
              className="flex items-center gap-3 px-4 py-2.5 bg-white hover:bg-gray-100 transition rounded-2xl shadow-md text-gray-800 font-medium"
            >
              <FcGoogle className="w-4 h-4" />
              <span>Continuar con Google</span>
            </button>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default HomeScreen;